import request from '@/utils/request';

// 查询参数列表
export function listConfig(query) {
  return request({
    url: '/system/config/sysConfig/list',
    method: 'get',
    params: query
  });
}

// 查询参数详细
export function getConfig(configId) {
  return request({
    url: '/system/config/sysConfig/one/?id=' + configId,
    method: 'get'
  });
}

// 根据参数键名查询参数值
export function getConfigKey(configKey) {
  return request({
    url: '/system/config/configKey/' + configKey,
    method: 'get'
  });
}

// 新增参数配置
export function addConfig(data) {
  return request({
    url: '/system/config/sysConfig/add',
    method: 'post',
    data: data
  });
}

// 修改参数配置
export function updateConfig(data) {
  return request({
    url: '/system/config/sysConfig/edit',
    method: 'put',
    data: data
  });
}

// 删除参数配置
export function delConfig(configId) {
  return request({
    url: '/system/config/sysConfig/delete',
    method: 'delete',
    data: {
      ids: configId
    }
  });
}

// 导出参数
export function exportConfig(query) {
  return request({
    url: '/system/config/export',
    method: 'get',
    params: query
  });
}
//获取邮箱配置列表
export function getEmailList() {
  return request({
    url: '/system/config/email/list',
    method: 'get'
  });
}
//设置邮箱配置列表
export function setEmailList(data) {
  return request({
    url: '/system/config/email/edit',
    method: 'post',
    data: data
  });
}

//获取oss配置列表
export function getOssList() {
  return request({
    url: '/system/config/oss/list',
    method: 'get'
  });
}
//设置Oss配置列表
export function setOssList(data) {
  return request({
    url: '/system/config/oss/edit',
    method: 'post',
    data: data
  });
}

//获取短信配置列表
export function getSmsList() {
  return request({
    url: '/system/config/sms/list',
    method: 'get'
  });
}
//设置短信配置列表
export function setSmsList(data) {
  return request({
    url: '/system/config/sms/edit',
    method: 'post',
    data: data
  });
}